import { store } from '@context/store';
import { convertCurrency, showIsoCode } from '@helpers/currencyConverter';
import useSessionStorage from '@hooks/useSessionStorage';
import React, { useContext, useEffect, useState } from 'react';

type Props = {
  value: number | string;
  precision?: number;
  spaceBetween?: boolean;
  valueClasses?: string;
  isoCodeClasses?: string;
  showAsterisk?: boolean;
};
export default function Currency({
  value,
  valueClasses = 'text-21 font-rp-pn-regular',
  isoCodeClasses = 'text-15 font-rp-pn-regular',
  precision = 0,
  spaceBetween = true,
  showAsterisk = false,
}: Props) {
  const globalState = useContext(store);
  const { state } = globalState;
  const { selectedCurrency } = state;
  const { iso_code: isoCode } = selectedCurrency;
  const { getItem } = useSessionStorage();
  const finalValue = convertCurrency(value, state, precision);

  const [shouldShowIsoCode, setShouldShowIsoCode] = useState(false);

  // Only update ISO code visibility after component mounts on client
  useEffect(() => {
    const isShowIsoCode = showIsoCode(state, getItem);
    setShouldShowIsoCode(isShowIsoCode);
  }, [state, getItem]);

  return (
    <span className={valueClasses}>
      {finalValue}
      {shouldShowIsoCode && (
        <span className={isoCodeClasses}>{spaceBetween ? ` ${isoCode}` : isoCode}</span>
      )}
      {showAsterisk && ' *'}
    </span>
  );
}
